module.exports = __webpack_public_path__ + "img/笑脸.b6053759.png";